import { el } from './dom';

/**
 * Finestra di dialogo in stile RPG: coda di battute, avanzamento con
 * click/tap o col tasto azione. `say()` ritorna una Promise risolta quando
 * il giocatore ha letto tutto.
 */

export class DialogUi {
  private box: HTMLDivElement;
  private speakerEl: HTMLSpanElement;
  private textEl: HTMLParagraphElement;
  private advance: (() => void) | null = null;

  constructor(uiRoot: HTMLElement) {
    this.box = el('div', 'dialog-box panel');
    this.box.style.display = 'none';
    this.speakerEl = el('span', 'speaker');
    this.textEl = el('p');
    this.textEl.style.margin = '4px 0 10px';
    const hint = el('span', 'hint', '▼ continua');
    this.box.append(this.speakerEl, this.textEl, hint);
    this.box.addEventListener('pointerdown', () => this.advance?.());
    uiRoot.appendChild(this.box);
  }

  get isOpen(): boolean {
    return this.box.style.display !== 'none';
  }

  /** Da collegare al tasto azione dell'InputManager. */
  handleInteract(): boolean {
    if (!this.isOpen) return false;
    this.advance?.();
    return true;
  }

  async say(lines: string[], speaker?: string): Promise<void> {
    this.box.style.display = 'block';
    this.speakerEl.style.display = speaker ? 'inline-block' : 'none';
    if (speaker) this.speakerEl.textContent = speaker;
    for (const line of lines) {
      this.textEl.textContent = line;
      await new Promise<void>((resolve) => {
        this.advance = resolve;
      });
      this.advance = null;
    }
    this.box.style.display = 'none';
  }
}
